import UsersTable from "./UsersTable";

export default function Packer() {
  return <UsersTable type="packer" />;
}
